import { render, staticRenderFns } from "./orderBuyList.vue?vue&type=template&id=b8f2932c"
import script from "./orderBuyList.vue?vue&type=script&lang=js"
export * from "./orderBuyList.vue?vue&type=script&lang=js"
import style0 from "./orderBuyList.vue?vue&type=style&index=0&id=b8f2932c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports